<template>
  <div>
    <FlowLineThreeSteps :steps="threeSteps" :active-step="2" />
  </div>
</template>
<script>
import FlowLineThreeSteps from '../../../atoms/flow_lines/FlowLineThreeSteps.vue'

export default {
  components: { FlowLineThreeSteps },
  data() {
    return {
      threeSteps: ['入力', '確認', '完了']
    }
  }
}
</script>
